// extracted by mini-css-extract-plugin
module.exports = {"rotation":"ProgettiSection_rotation__xvxgz"};